import { t } from "../../i18n";
import type { WallInput } from "@tasduvar/engine";
import { NumberField } from "../../ui/NumberField";
import { Select } from "../../ui/Select";

type Side = "none" | "front" | "back";

/**
 * Parsel sınırı seçimi (Cem 2026-10-02): temelin taşamayacağı taraf + gövde yüzünden sınıra uzaklık. Akıllı tasarım ve
 * Yeniden boyutlandır bu sınırın dışına çıkmadan boyutlar; elle aşılırsa hesap uyarı verir. Kesitte burun solda, dolgu sağda.
 */
export function PropertyLineFields({ wall, update, idPrefix }: { wall: WallInput; update: (recipe: (w: WallInput) => void) => void; idPrefix: string }): JSX.Element {
  const pl = wall.propertyLine;
  const side: Side = pl?.side ?? "none";
  return (
    <>
      <Select<Side> id={`${idPrefix}-pl`} label={t("Dışına çıkılamayacak taraf")} value={side}
        hint={t("Kesitte ön (burun) solda, arka (dolgu) sağda")}
        options={[
          { value: "none", label: t("Yok — temel iki yana da çıkabilir") },
          { value: "front", label: t("Sol — ön taraf: burun yapılmaz") },
          { value: "back", label: t("Sağ — arka taraf: topuk yapılmaz") },
        ]}
        onChange={(v) => update((w) => { w.propertyLine = v === "none" ? undefined : { side: v, clearance: w.propertyLine?.clearance ?? 0 }; })} />
      {pl ? <NumberField id={`${idPrefix}-plc`} label={t("Gövde yüzünden sınıra uzaklık")} unit="m" value={pl.clearance} min={0} max={10} digits={2}
        hint={t("0 = gövde yüzü sınırda; o yandaki temel çıkıntısı bu değeri aşmaz")}
        onChange={(v) => update((w) => { if (w.propertyLine) w.propertyLine.clearance = v; })} /> : null}
    </>
  );
}
